/**************************************************
 * Nombre:       Tarjeta_Habitacion_Vista
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Tooltip, Typography} from "@mui/material";
import hab_lista from "../../Recursos/hab_lista.svg";
import hab_reservada from "../../Recursos/hab_reservada.svg";
import hab_sucia from "../../Recursos/hab_sucia.svg";
import hab_salida from "../../Recursos/hab_salida.svg";
import hab_ocupada from "../../Recursos/hab_ocupada.svg";
import hab_potencial from "../../Recursos/hab_potencial.svg";
import hab_mantenimiento from "../../Recursos/hab_mantenimiento.svg";
import {ESTADOSHABITACIONES, ESTADOSRESERVAS, FECHACHECKIN, FECHACHECKOUT} from "../../Constantes";
import {useEffect, useState} from "react";
import {obtenerFechaEstandarCheckIn} from "../../Funciones/obtenerFechaEstandarCheckIn";
import {obtenerFechaEstandarCheckOut} from "../../Funciones/obtenerFechaEstandarCheckOut";
import {formatoMoneda} from "../../../Utilidades/formatoMoneda";
import {obtenerValorSaldo} from "../../../CodNegocio/obtenerValorSaldo";

const Tarjeta_Habitacion_Vista = ({item, click, reservasDia, fechaDia}) => {
    const [reserva, setReserva] = useState(null)

    const obtenerImgHabitacion = (reserva) => {

        if (reserva) {


            let fechaIn = obtenerFechaEstandarCheckIn(fechaDia)
            let fechaOut = obtenerFechaEstandarCheckOut(fechaDia)

            if (reserva.estado === ESTADOSRESERVAS[3]) {
                return hab_sucia
            }

            if (reserva[FECHACHECKOUT] === fechaOut && reserva.estado !== ESTADOSRESERVAS[3]) {
                return hab_salida
            }

            if (reserva.estado === ESTADOSRESERVAS[1]) {
                return hab_ocupada
            }

            if (reserva.estado === ESTADOSRESERVAS[6]) {
                return hab_potencial
            }

            if (reserva[FECHACHECKIN] === fechaIn) {
                return hab_reservada
            }


        } else {
            switch (item.estado) {
                case ESTADOSHABITACIONES[0]:
                    return hab_lista
                case ESTADOSHABITACIONES[1]:
                    return hab_mantenimiento
                default:
                    return hab_lista
            }
        }


    }

    const obtenerReserva = (item) => {

        let index = reservasDia.findIndex((e) => e.numero === item.numero)
        if (index > -1) {
            return reservasDia[index]
        } else {
            return null
        }

    }

    useEffect(() => {
        setReserva(obtenerReserva(item))
    }, [item, reservasDia]);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-end'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Typography sx={{fontWeight: 600, fontSize: 14}}>{`${item?.numero}`}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: -0.5}}>
                <Typography sx={{fontSize: 12}}>{item?.tipo}</Typography>
            </Grid>

            <Grid
                onClick={(e) => {
                    if (reserva)
                        click(e, reserva)
                }}
                container size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    justifyContent: 'center',
                    mt: 1,
                    cursor: 'pointer',
                }}>
                <Tooltip title={`${reserva ? reserva.estado : item.estado} ${reserva ? reserva.nombres : ''}`}>
                    <img src={obtenerImgHabitacion(reserva)} width={'100%'} height={'auto'}/>
                </Tooltip>

            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 0.5}}>
                {reserva?.valor &&
                    <Typography
                        sx={{fontSize: 10}}>{`Saldo ${formatoMoneda(obtenerValorSaldo({
                        totalReserva: reserva.valor,
                        descuentos: reserva.descuentos,
                        adicionales: reserva.adicionales,
                        abonos: reserva.abonos
                    }))}`}</Typography>
                }
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Habitacion_Vista